import React from "react";
import Card from "../common/Card";
import { GameContext } from "../../context/GameContext";

const QuestionContainer = () => {
  const { questionsArray, currentQuestion } = React.useContext(GameContext);
  return (
    <div className="desktop-question_container">
      <div className="image_container">
        <img
          src={questionsArray[currentQuestion].img}
          alt={`Tecknad bild föreställande ${questionsArray[currentQuestion].name}`}
        />
      </div>
      <Card />
    </div>
  );
};

export default QuestionContainer;
